import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Stack, NavLink, Divider, Box, ScrollArea } from '@mantine/core';
import { 
  IconHome, 
  IconPackage, 
  IconInfoCircle, 
  IconMail,
  IconTruck,
  IconRefresh,
  IconQuestionMark
} from '@tabler/icons-react';
import { useLanguage } from '@/context/LanguageContext';
import { LanguageSelector } from './LanguageSelector';

interface MobileNavProps {
  onClose: () => void;
}

export const MobileNav: React.FC<MobileNavProps> = ({ onClose }) => {
  const { t } = useLanguage();
  const location = useLocation();

  const mainLinks = [
    { to: '/', label: t('nav.home'), icon: IconHome },
    { to: '/products', label: t('nav.products'), icon: IconPackage },
    { to: '/about-us', label: t('nav.aboutUs'), icon: IconInfoCircle },
    { to: '/contact', label: t('footer.contactUs'), icon: IconMail },
  ];

  const supportLinks = [
    { to: '/shipping', label: t('footer.shippingInfo'), icon: IconTruck },
    { to: '/returns', label: t('footer.returnsExchanges'), icon: IconRefresh },
    { to: '/faq', label: t('footer.faq'), icon: IconQuestionMark },
  ];

  return (
    <>
      <ScrollArea flex={1} p="md">
        <Stack gap="xs">
          {mainLinks.map((link) => (
            <NavLink
              key={link.to}
              component={Link}
              to={link.to}
              label={link.label}
              leftSection={<link.icon size={20} stroke={1.5} />}
              active={location.pathname === link.to}
              onClick={onClose}
              styles={{
                root: {
                  borderRadius: '8px',
                },
              }}
            />
          ))}
        </Stack>

        <Divider my="md" label={t('footer.customerService')} labelPosition="left" />

        <Stack gap="xs">
          {supportLinks.map((link) => (
            <NavLink
              key={link.to}
              component={Link}
              to={link.to}
              label={link.label}
              leftSection={<link.icon size={20} stroke={1.5} />}
              active={location.pathname === link.to}
              onClick={onClose}
              variant="subtle"
              styles={{
                root: {
                  borderRadius: '8px',
                },
              }}
            />
          ))}
        </Stack>
      </ScrollArea>

      <Box p="md" style={{ borderTop: '1px solid var(--mantine-color-gray-2)' }}>
        <LanguageSelector />
      </Box>
    </>
  );
};

